import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ISizeName } from '@df/core/service/client';
import { ImageModule } from '@df/module-image/image.module';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ModalLayoutMiddleComponent, NModalLayoutMiddle } from 'projects/app-default/src/app/ui/modal/modal-layout-middle.component';
export const IMAGE_ZOOM_MODAL_ID = 'image-zoom-modal';
export namespace NCmsImageZoomModal {
    export const BLOCK_ID = IMAGE_ZOOM_MODAL_ID;
    export type IBlockData = Catalog.IBlockData<IBlockContent>;
    export interface IBlockContent {
        btnCopy: string;
    }
}
@DfCmsModal({
    id: NCmsImageZoomModal.BLOCK_ID,
    name: 'Image Zoom Modal',
    position: 'left',
    config: (sizeId: ISizeName) => ({
        ...NModalLayoutMiddle.ModalConfig,
        width: '100vw',
        modalClass: 'p-a-0',
        height: '100vh'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@ICmsComponent<CmsImageZoomModalComponent>({
    name: 'Image Zoom Modal',
    block: { url: NCmsImageZoomModal.BLOCK_ID },
    id: NCmsImageZoomModal.BLOCK_ID,
    fields: [
        <NICmsContentField.IField>{
            key: 'btnCopy',
            type: NICmsContentField.EFieldType.text,
            title: 'Button copy',
            required: true
        }
    ]
})
@Component({
    selector: 'image-zoom-modal',
    templateUrl: './image-zoom-modal.html',
    styleUrls: ['image-zoom-modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ImageModule, CommonModule, ModalLayoutMiddleComponent, ICmsClientModule, OffClickDirective]
})
export class CmsImageZoomModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsImageZoomModal.IBlockContent;
    zoomImg: string = this.data;

    constructor(
        @Optional() @Inject(MODAL_DATA) protected data: string,
        @Optional()
        private modalRef: ModalRef<CmsImageZoomModalComponent>
    ) {
        super();
    }

    protected close() {
        this.modalRef?.close();
    }
}
